'use client'

import { EASE_OUT_CUBIC, MENU_DURATION } from '@/helpers/timing'
import { motion } from 'motion/react'
import type { PropsWithChildren } from 'react'
import { useCallback, useRef, useState, type FC } from 'react'

export type ResizingContainerProps = {
	className?: string
}

export const ResizingContainer: FC<PropsWithChildren<ResizingContainerProps>> = ({
	className,
	children,
}) => {
	const [height, setHeight] = useState<string | number>('auto')
	const contentRef = useRef<HTMLDivElement>(null)

	const ref = useCallback((node: HTMLDivElement | null) => {
		const inner = contentRef.current
		if (!node || !inner) return

		const updateContentHeight = () => setHeight(inner.offsetHeight)
		const obs = new ResizeObserver(updateContentHeight)
		obs.observe(inner)
		return () => obs.disconnect()
	}, [])

	return (
		<motion.div
			ref={ref}
			className={className}
			animate={{ height }}
			transition={{ duration: MENU_DURATION, ease: EASE_OUT_CUBIC }}
		>
			<div ref={contentRef}>{children}</div>
		</motion.div>
	)
}
